import { WebviewInstanceId } from '@gitlab-org/webview-plugin';

export type ManagedInstances = Set<WebviewInstanceId>;
export type IsManagedEventFilter = <TEvent extends { webviewInstanceId: WebviewInstanceId }>(
  event: TEvent,
) => boolean;

export const createIsManagedFunc =
  (managedInstances: ManagedInstances): IsManagedEventFilter =>
  <TEvent extends { webviewInstanceId: WebviewInstanceId }>(event: TEvent) =>
    managedInstances.has(event.webviewInstanceId);
